import React, { useEffect, useState } from "react";
import ItemTable from "../../Components/Card/MaterEntryCards/ItemTable";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Form } from "react-bootstrap";
import {
  Button,
  RadioGroup,
  Select,
  MenuItem,
  TextField,
  Tooltip,
  FormControl,
  InputLabel,
  Grid,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  InputAdornment,
  FormHelperText,
  Box,
} from "@mui/material";
import MyFormControlLabel from "@mui/material/FormControlLabel";
import { Radio } from "@mui/material";
import configServ from "../../services/config";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import NextPlanIcon from "@mui/icons-material/NextPlan";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import CancelIcon from "@mui/icons-material/Cancel";
import { Stack, Paper, Divider, Typography } from "@mui/material";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import CardHeadMenu from "../Card/CardHeadMenu/CardHeadMenu";
import RotateLeftIcon from "@mui/icons-material/RotateLeft";
import SaveIcon from "@mui/icons-material/Save";
import UpdateIcon from "@mui/icons-material/Update";
import { triggerLoader } from "../../redux/reducers/LoaderTrigger";
import CheckAndReturn from "../../utility/CheckAndReturn";
import Questionnaires from "../Questionnaire/Questionnaires";
import Swal from "sweetalert2";
import { handleLabel } from "../../utility/Common";
import SolutionTable from "../Card/MaterEntryCards/SolutionTable";
import { AddPhotoAlternate } from "@mui/icons-material";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import ChapterForm from "./ChapterForm";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
//FUNCTION
const Solutions = () => {
  //#region code
  const { user_id, company_id, noRoomService } = useSelector(
    (state) => state.GlobalVariables
  );
  const { company_type } = useSelector((state) => state.admin);
  const dispatch = useDispatch();
  const [formDataInitial, setFormDataInitial] = useState({
    title: "",
    description: "",
    language: "",
    start_date: "",
    level: "beginner",
    price: "0",
    duration: "",
    access_type: "draft",
    image_path: "",
    certificate_provided: false,
    settings: null,
    mode: "",
    brand_id: "",
    max_students: "",
    discount_price: "",
    price_unit_id: "",
  });

  const handleImageUpload = (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];
    const maxSize = 2 * 1024 * 1024; // 2MB in bytes

    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG or PNG files are allowed.");
      return;
    }

    if (file.size > maxSize) {
      alert("File size should not exceed 2MB.");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setFormData((prev) => ({
        ...prev,
        image_path: reader.result, // Base64 string
      }));
    };
    reader.readAsDataURL(file);
  };

  const [formData, setFormData] = useState(formDataInitial);
  const [categoryList, setCategoryList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [superCategoryList, setSuperCategoryList] = useState([]);
  const [groupList, setGroupList] = useState([]);
  const [unitList, setUnitList] = useState([]);
  const [hsnList, setHsnList] = useState([]);
  const [locationList, setLocationList] = useState([]);
  const [companyType, setCompanyType] = useState(company_type);
  const [hsn, setHsn] = useState("");
  const [questionnaires, setQuestionnaires] = useState([]);

  const [tableData, setTableData] = useState([]);
  const [isEdit, setIsEdit] = useState(false);
  const [priceUnitList, setPriceUnitList] = useState([]);
  const [openAddImage, setOpenAddImage] = useState(false);
  const [openAddSize, setOpenAddSize] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [isItemName, setIsItemName] = useState(false);
  const [isItemCode, setIsItemCode] = useState(true);
  const navigate = useNavigate();
  const [associatedItem, setAssociatedItem] = useState([
    {
      id: 1,
      item_id: "",
      qty: "",
    },
  ]);
  const [isCreate, setIsCreate] = useState(false);
  const [isChanged, setIsChanged] = useState(false);

  const handlePopup = () => {
    try {
      if (isCreate === true) {
        clear();
      }
      setIsCreate(!isCreate);
    } catch (error) {
      console.log(error);
    }
  };

  const addAssociatedItem = () => {
    setAssociatedItem((state) => [
      ...state,
      {
        id: associatedItem.length + 1,
        item_id: "",
        qty: "",
      },
    ]);
  };
  const delAssociatedItem = (id) => {
    const updatedItemList = associatedItem.filter((item) => item.id !== id);
    setAssociatedItem(updatedItemList);
  };
  const handleChangeAssociatedItem = (id, event) => {
    const { name, value } = event.target;
    setAssociatedItem((state) =>
      state.map((item) => (item.id === id ? { ...item, [name]: value } : item))
    );
    if (name === "item_id") {
      const selectedItem = tableData.filter((item) => value === item.id);
      setAssociatedItem((state) =>
        state.map((item) =>
          item.id === id
            ? { ...item, item_name: selectedItem[0].item_name }
            : item
        )
      );
    }
  };

  const fetchItemList = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getVideoReferennces(dataToSend);
      if (res.status === 200) {
        const result = res.data;
        if (result.length > 0) {
          setTableData(result);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    const fetchPriceUnits = async () => {
      try {
        const res = await configServ.getPriceUnits();
        if (res.status === "success") {
          setPriceUnitList(res.data); // 'data' ke andar 'data' Laravel format hai
        }
      } catch (error) {
        console.error("Error fetching price units:", error);
      }
    };

    fetchPriceUnits();
  }, []);

  // const fetchSuperCategory = async () => {
  //   try {
  //     const res = await configServ.getSuperCategory();
  //     const superCategoryResponse = res.data.filter(x => x.status === 1);
  //     superCategoryResponse.map((item) => {
  //       if (item.isPrimary === 1) {
  //         setFormData((prev) => ({
  //           ...prev,
  //           superCategory: item.id
  //         }));
  //         setFormDataInitial((prev) => ({
  //           ...prev,
  //           superCategory: item.id
  //         }));
  //       }
  //     });
  //     const result = superCategoryResponse.sort((a, b) => a.name.localeCompare(b.name))
  //     setSuperCategoryList(result);
  //   }
  //   catch (e) {
  //     console.log(e);
  //   }
  // };

  const changeHandler = (e) => {
    const { name, value } = e.target;

    //Update form data
    setFormData((state) => ({
      ...state,
      [name]: value,
    }));

    // Reset the validation error when the user starts typing
    if (validationErrors[name]) {
      setValidationErrors((prevValidationError) => ({
        ...prevValidationError,
        [name]: "",
      }));
    }
  };

  const checkHandler = (e) => {
    const { name, checked } = e.target;
    setFormData((state) => ({
      ...state,
      [name]: checked,
    }));
  };

  const fetchCategory = async () => {
    try {
      //const result = await configServ.getcategoryByBrand({ "brand_id": formData.brand_id });
      const dataToSend = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getcategory(dataToSend);
      if (res.status === 200) {
        const categoryResponse = res.data.filter((x) => x.status === 1);
        categoryResponse.map((item) => {
          if (item.isPrimary === 1) {
            setFormData((prev) => ({
              ...prev,
              category_id: item.categoryid.toString(),
            }));
            setFormDataInitial((prev) => ({
              ...prev,
              category_id: item.categoryid.toString(),
            }));
          }
        });
        const result = categoryResponse.sort((a, b) =>
          a.categoryname.localeCompare(b.categoryname)
        );
        setCategoryList(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchBrand = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getBrand(dataToSend);
      if (res.status === 200) {
        const brand_res = res.data.filter((x) => x.status === 1);
        brand_res.map((item) => {
          if (item.isPrimary === 1) {
            setFormData((prev) => ({
              ...prev,
              brand_id: item.id.toString(),
            }));
            setFormDataInitial((prev) => ({
              ...prev,
              brand_id: item.id.toString(),
            }));
          }
        });
        const result = brand_res.sort((a, b) =>
          a.brand_name.localeCompare(b.brand_name)
        );
        setBrandList(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchGroup = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getGroup(dataToSend);
      if (res.status === 200) {
        const groupResponse = res.data.filter((x) => x.status === 1);
        groupResponse.map((item) => {
          if (item.isPrimary === 1) {
            setFormData((prev) => ({
              ...prev,
              group_id: item.id,
            }));
            setFormDataInitial((prev) => ({
              ...prev,
              group_id: item.id,
            }));
          }
        });
        const result = groupResponse.sort((a, b) =>
          a.group_name.localeCompare(b.group_name)
        );
        setGroupList(result);
      }
    } catch (e) {
      console.log(e);
    }
  };

  // const fetchGroup = async () => {
  //   try {
  //     const res = await configServ.groupByCategory({
  //       category_id: formData.category_id,
  //     });

  //     if (res.status === 200) {

  //       const groupResponse = res.result.filter(x => x.status === 1);
  //       groupResponse.map((item) => {
  //         if (item.isPrimary === 1) {
  //           setFormData((prev) => ({
  //             ...prev,
  //             group_id: item.id
  //           }));
  //         }
  //       });
  //       setGroupList(groupResponse);
  //     }
  //     else if (res.status === 404) {
  //       const res = await configServ.getGroup({
  //         company_id: company_id,
  //       });
  //       if (res.status === 200) {
  //         const groupResponse = res.result.filter(x => x.status === 1);
  //         groupResponse.map((item) => {
  //           if (item.isPrimary === 1) {
  //             setFormData((prev) => ({
  //               ...prev,
  //               group_id: item.id
  //             }));
  //           }
  //         });
  //         setGroupList(groupResponse);
  //       }
  //       else {
  //         setGroupList([]);
  //       }
  //     }
  //     else {
  //       setGroupList([]);
  //     }
  //   }
  //   catch (error) {
  //     console.log(error);
  //   }
  // };

  // const fetchLocation = async () => {
  //   try {
  //     const res = await configServ.getLocation({
  //       company_id: company_id,
  //     });
  //     const locationResponse = res.filter(x => x.status === 1);
  //     locationResponse.map((item) => {
  //       if (item.isPrimary === 1) {
  //         setFormData((prev) => ({
  //           ...prev,
  //           location_id: item.id
  //         }));
  //         setFormDataInitial((prev) => ({
  //           ...prev,
  //           location_id: item.id
  //         }));
  //       }
  //     });
  //     const result = locationResponse.sort((a, b) => a.location_name.localeCompare(b.location_name));
  //     setLocationList(result);
  //   }
  //   catch (error) {
  //     console.log(error);
  //   }
  // };

  const fetchUnit = async () => {
    try {
      const dataToSend = {
        company_id: company_id,
        search_by: null,
        search: null,
        per_page: null,
        page: null,
      };
      const res = await configServ.getUnit(dataToSend);
      if (res.status === 200) {
        const unitResponse = res.data.filter((x) => x.status === 1);
        unitResponse.map((item) => {
          if (item.isPrimary === 1) {
            setFormData((prev) => ({
              ...prev,
              unit: item.units_name,
            }));
            setFormDataInitial((prev) => ({
              ...prev,
              unit: item.units_name,
            }));
          }
        });
        const result = unitResponse.sort((a, b) =>
          a.units_name.localeCompare(b.units_name)
        );
        setUnitList(result);
      }
    } catch (error) {
      console.log(error);
    }
  };

  // const fetchGstDetails = async () => {
  //   try {
  //     const dataToSend = {
  //       "company_id": company_id,
  //       "search_by": null,
  //       "search": null,
  //       "per_page": null,
  //       "page": null
  //     }
  //     const res = await configServ.getHsnList(dataToSend);
  //     if (res.status === 200) {
  //       const hsnResponse = res.data.filter(x => x.ActiveFlage === 1);
  //       hsnResponse.map((item) => {
  //         const hsn_sac = item.hsncode;
  //         if (item.isPrimary === 1) {
  //           setHsn(hsn_sac);
  //           setFormData((prev) => ({
  //             ...prev,
  //             hsncode: hsn_sac,
  //             tax_rate: item.GSTRate,
  //           }));
  //           setFormDataInitial((prev) => ({
  //             ...prev,
  //             hsncode: hsn_sac,
  //             tax_rate: item.GSTRate
  //           }));
  //         }
  //       });
  //       setHsnList(hsnResponse);
  //     }
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  useEffect(() => {
    //fetchSuperCategory();
    fetchCategory();
    fetchBrand();
    fetchGroup();
    fetchUnit();
    //fetchGstDetails();
    //fetchLocation();
    setValidationErrors({});
  }, []);

  // useEffect(()=>{
  //     if(formData.brand_id){
  //         fetchCategory();
  //     }
  // },[formData.brand_id]);

  // useEffect(() => {
  //   if (formData.category_id) {
  //     fetchGroup();
  //   }
  // }, [formData.category_id]);

  useEffect(() => {
    if (formData.item_type === "composite") {
      fetchItemList();
    }
  }, [formData.item_type]);

  // const itemUpdated = () => {
  //     setIsItemUpdated(!isItemUpdated)
  // }

  const handleEdit = async (data) => {
    console.log("handleEdit", data);
    setIsCreate(true);
    setValidationErrors({});
    setCompanyType(data.type);
    setHsn(data.hsncode);
    setFormData({
      ...data,
      image_path: data.image_base64 || "", // fallback to base64 or empty
    });
    setIsEdit(true);
  };

  // const fetchAssociatedItem = async (id) => {
  //   try {
  //     const result = await configServ.getAssociateItem({
  //       associatedWith_id: id,
  //     });
  //     setAssociatedItem(result);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };

  const handleSubmit = async () => {
    try {
      dispatch(triggerLoader());
      const itemData = {
        ...formData,
        company_id: company_id,
        created_by: user_id,
      };

      const error = await handleFormValidation();
      if (error === false) {
        return false;
      }
      setValidationErrors({});
      if (!isEdit) {
        const res = await configServ.createCourse(itemData);
        if (res.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Course created successfully.",
          });
          clear();
          setIsChanged(!isChanged);
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to create Course.",
          });
        }
      } else {
        const res = await configServ.updateCourse(itemData);
        if (res.success) {
          Swal.fire({
            icon: "success",
            title: "Success",
            text: "Course updated successfully.",
          });
          clear();
          setIsChanged(!isChanged);
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to update Course.",
          });
        }
      }
    } catch (e) {
      console.log(e);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "An unexpected error has occurred.",
      });
    } finally {
      dispatch(triggerLoader());
    }
  };

  const clear = () => {
    setFormData(formDataInitial);
    setIsEdit(false);
    setIsItemName(false);
    setIsItemCode(true);
    //fetchGstDetails();
    setCompanyType(company_type);
    setValidationErrors({});
    setAssociatedItem([
      {
        id: 1,
        item_id: "",
        qty: "",
      },
    ]);
  };

  // const handleCloseImage = () => {
  //   setOpenAddImage(false);
  // };

  // const handleOpenImage = () => {
  //   setOpenAddImage(true);
  // };

  // const handleCloseSize = () => {
  //   setOpenAddSize(false);
  // };

  // const handleOpenSize = () => {
  //   setOpenAddSize(true);
  // };

  // const formArrayZeroToN = (number) => {
  //   if (
  //     typeof number !== "number" ||
  //     !Number.isInteger(number) ||
  //     number <= 0
  //   ) {
  //     throw new Error("Input must be a positive integer");
  //   }

  //   return Array.from({ length: number }, (_, index) => index + 1);
  // };

  const handleHSN = (selectedhsn) => {
    if (selectedhsn === null) {
      setHsn("");
      setFormData((state) => ({
        ...state,
        hsncode: "",
        tax_rate: "",
      }));
    } else {
      const hsn = hsnList.filter(
        (x) => x.hsncode === selectedhsn.hsncode.toString()
      )[0];
      setHsn(hsn.hsncode);
      setFormData((state) => ({
        ...state,
        hsncode: hsn.hsncode,
        tax_rate: hsn.GSTRate,
      }));
    }
  };

  const handleFormValidation = async () => {
    const errors = {};

    if (!formData.title || formData.title.trim() === "") {
      errors.title = "Title is required";
    }

    if (!formData.level) {
      errors.level = "Level is required";
    }

    if (formData.price === "" || isNaN(formData.price)) {
      errors.price = "Price is required";
    }

    if (!formData.access_type) {
      errors.access_type = "Access type is required";
    }

    if (
      !formData.image_path ||
      !formData.image_path.startsWith("data:image/")
    ) {
      errors.image_path = "Valid course image is required";
    }

    setValidationErrors(errors);

    return Object.keys(errors).length === 0;
  };

  // const checkItemCode = async () => {
  //   try {
  //     const dataToSend = {
  //       item_code: formData.item_code,
  //     }
  //     const res = await configServ.checkItemCode(dataToSend);
  //     if (res.status === 200) {
  //       setIsItemCode(true);
  //     }
  //     else {
  //       setIsItemCode(false);
  //     }
  //   }
  //   catch (e) {
  //     console.log(e);
  //   }
  // }

  // useEffect(() => {
  //   if (formData.item_code && formData.item_code.length > 3) {
  //     checkItemCode();
  //   }
  //   else if (formData.item_code && formData.item_code.length < 4) {
  //     setIsItemCode(false);
  //   }
  //   else if (CheckAndReturn.checkError(formData.item_code)) {
  //     setIsItemCode(true);
  //   }
  //   else {
  //     setIsItemCode(false);
  //   }
  // }, [formData.item_code]);

  const checkItemName = async () => {
    try {
      const dataToSend = {
        item_name: formData.item_name,
      };
      const res = await configServ.checkSolution(dataToSend);
      if (res.status === 200) {
        setIsItemName(true);
      } else {
        setIsItemName(false);
      }
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(() => {
    if (formData.item_name) {
      checkItemName();
    }
  }, [formData.item_name]);

  const handleQuestionnaires = (params) => {
    try {
      setQuestionnaires(true);
    } catch (e) {
      console.log(e);
    }
  };

  const quillModules = {
    toolbar: [
      [{ header: [1, 2, 3, false] }],
      [{ font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike"],
      [{ color: [] }, { background: [] }], // ✅ Text and background color
      [{ script: "sub" }, { script: "super" }],
      [{ list: "ordered" }, { list: "bullet" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ align: [] }],
      ["link", "image", "video"],
      ["clean"], // remove formatting
    ],
  };

  const quillFormats = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "strike",
    "color",
    "background",
    "script",
    "list",
    "bullet",
    "indent",
    "align",
    "link",
    "image",
    "video",
  ];

  //#endregion

  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Courses"}
        handlePopup={handlePopup}
        isEdit={isEdit}
        create={isCreate}
      />

      {isCreate === true && (
        <Container>
          <motion.div
            style={{
              width: "100%",
              backgroundColor: "#e3f3fc",
              padding: 20,
              borderRadius: "10px",
              border: "none",
            }}
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.1, delay: 0.1 }}
          >
            <Grid
              container
              alignItems="flex-end"
              justifyContent="flex-start"
              spacing={1}
            >
              <Grid container spacing={2} alignItems="center">
                {/* Course Title */}
                <Grid item xs={12} md={6}>
                  <TextField
                    name="title"
                    label="Course Title"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={formData.title || ""}
                    onChange={changeHandler}
                    error={!!validationErrors.title}
                    helperText={validationErrors.title}
                    sx={{ width: "100%", backgroundColor: "white" }}
                  />
                </Grid>
                <Grid item xs={12} md={6}>
                  <Autocomplete
                    options={brandList}
                    getOptionLabel={(option) => option.brand_name || ""}
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    value={
                      brandList.find(
                        (b) => b.id === parseInt(formData.brand_id)
                      ) || null
                    }
                    onChange={(event, newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        brand_id: newValue ? newValue.id.toString() : "",
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        label="Select Brand"
                        size="small"
                        fullWidth
                        error={!!validationErrors.brand_id}
                        helperText={validationErrors.brand_id}
                        sx={{ backgroundColor: "white" }}
                      />
                    )}
                  />
                </Grid>

                {/* Description */}
                <Grid item xs={12} md={12}>
                  <label
                    style={{
                      fontSize: "14px",
                      fontWeight: 500,
                      marginBottom: "4px",
                      display: "block",
                    }}
                  >
                    Description
                  </label>
                  <ReactQuill
                    theme="snow"
                    value={formData.description || ""}
                    onChange={(value) =>
                      changeHandler({ target: { name: "description", value } })
                    }
                    modules={quillModules} // ✅ pass the modules
                    formats={quillFormats} // ✅ pass the formats
                    style={{
                      backgroundColor: "white",
                      minHeight: "120px",
                      borderRadius: "4px",
                    }}
                  />
                </Grid>
                {/* language */}
                <Grid item xs={12} md={3}>
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{ backgroundColor: "white" }}
                  >
                    <InputLabel id="language-label">Language</InputLabel>
                    <Select
                      labelId="language-label"
                      name="language"
                      label="Language"
                      value={formData.language || ""}
                      onChange={changeHandler}
                    >
                      <MenuItem value="english">English</MenuItem>
                      <MenuItem value="hindi">Hindi</MenuItem>
                      <MenuItem value="french">French</MenuItem>
                      <MenuItem value="spanish">Spanish</MenuItem>
                      <MenuItem value="german">German</MenuItem>
                      <MenuItem value="chinese">Chinese</MenuItem>
                      <MenuItem value="japanese">Japanese</MenuItem>
                      <MenuItem value="arabic">Arabic</MenuItem>
                      <MenuItem value="portuguese">Portuguese</MenuItem>
                      <MenuItem value="russian">Russian</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {/* Date */}
                <Grid item xs={12} md={3}>
                  <TextField
                    name="start_date"
                    label="Start Date"
                    type="date"
                    fullWidth
                    size="small"
                    InputLabelProps={{ shrink: true }}
                    value={formData.start_date || ""}
                    onChange={changeHandler}
                    sx={{ backgroundColor: "white" }}
                  />
                </Grid>
                {/* Mode */}
                <Grid item xs={12} md={3}>
                  <FormControl
                    fullWidth
                    size="small"
                    sx={{ backgroundColor: "white" }}
                  >
                    <InputLabel id="mode-label">Mode</InputLabel>
                    <Select
                      labelId="mode-label"
                      name="mode"
                      label="Mode"
                      value={formData.mode || ""}
                      onChange={changeHandler}
                    >
                      <MenuItem value="online">Online</MenuItem>
                      <MenuItem value="offline">Offline</MenuItem>
                      <MenuItem value="virtual">Virtual</MenuItem>
                      <MenuItem value="hybrid">Hybrid</MenuItem>
                      <MenuItem value="classroom">Classroom</MenuItem>
                      <MenuItem value="self-paced">Self-Paced</MenuItem>
                      <MenuItem value="instructor-led">Instructor-Led</MenuItem>
                      <MenuItem value="webinar">Webinar</MenuItem>
                      <MenuItem value="bootcamp">Bootcamp</MenuItem>
                      <MenuItem value="live-session">Live Session</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>
                {/* Price */}
                <Grid item xs={12} md={3}>
                  <TextField
                    name="price"
                    label="Price"
                    fullWidth
                    variant="outlined"
                    size="small"
                    type="number"
                    value={formData.price || ""}
                    onChange={changeHandler}
                    error={!!validationErrors.price}
                    helperText={validationErrors.price}
                    sx={{ width: "100%", backgroundColor: "white" }}
                  />
                </Grid>
                {/* Duration */}
                <Grid item xs={12} md={3}>
                  <TextField
                    name="duration"
                    label="Duration"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={formData.duration || ""}
                    onChange={changeHandler}
                    sx={{ width: "100%", backgroundColor: "white" }}
                  />
                </Grid>
                {/* Level */}
                <Grid item xs={12} md={3}>
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!validationErrors.level}
                  >
                    <InputLabel>Level</InputLabel>
                    <Select
                      name="level"
                      value={formData.level || ""}
                      onChange={changeHandler}
                      label="Level"
                      sx={{ backgroundColor: "white" }}
                    >
                      <MenuItem value="beginner">Beginner</MenuItem>
                      <MenuItem value="intermediate">Intermediate</MenuItem>
                      <MenuItem value="advanced">Advanced</MenuItem>
                    </Select>
                    {validationErrors.level && (
                      <FormHelperText>{validationErrors.level}</FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                {/* Access Type */}
                <Grid item xs={12} md={3}>
                  <FormControl
                    fullWidth
                    size="small"
                    error={!!validationErrors.access_type}
                  >
                    <InputLabel>Access Type</InputLabel>
                    <Select
                      name="access_type"
                      value={formData.access_type || ""}
                      onChange={changeHandler}
                      label="Access Type"
                      sx={{ backgroundColor: "white" }}
                    >
                      <MenuItem value="free">Free</MenuItem>
                      <MenuItem value="private">Private</MenuItem>
                      <MenuItem value="draft">Draft</MenuItem>
                    </Select>
                    {validationErrors.access_type && (
                      <FormHelperText>
                        {validationErrors.access_type}
                      </FormHelperText>
                    )}
                  </FormControl>
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name="max_students"
                    label="Max Students"
                    type="number"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={formData.max_students || ""}
                    onChange={changeHandler}
                    error={!!validationErrors.max_students}
                    helperText={validationErrors.max_students}
                    sx={{ backgroundColor: "white" }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <TextField
                    name="discount_price"
                    label="Discount Price"
                    type="number"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={formData.discount_price || ""}
                    onChange={changeHandler}
                    error={!!validationErrors.discount_price}
                    helperText={validationErrors.discount_price}
                    sx={{ backgroundColor: "white" }}
                  />
                </Grid>
                <Grid item xs={12} md={3}>
                  <Autocomplete
                    options={priceUnitList}
                    getOptionLabel={(option) =>
                      option.name && option.symbol
                        ? `${option.name} (${option.symbol})`
                        : ""
                    }
                    isOptionEqualToValue={(option, value) =>
                      option.id === value.id
                    }
                    value={
                      priceUnitList.find(
                        (unit) => unit.id === parseInt(formData.price_unit_id)
                      ) || null
                    }
                    onChange={(e, newValue) => {
                      setFormData((prev) => ({
                        ...prev,
                        price_unit_id: newValue ? newValue.id.toString() : "",
                      }));
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        name="price_unit_id"
                        label="Price Unit"
                        size="small"
                        fullWidth
                        error={!!validationErrors.price_unit_id}
                        helperText={validationErrors.price_unit_id}
                        sx={{ backgroundColor: "white" }}
                      />
                    )}
                  />
                </Grid>
                {/* Image Upload */}
                <Grid item xs={12} md={3}>
                  <Box display="flex" alignItems="center" gap={2}>
                    <Button
                      variant="outlined"
                      component="label"
                      size="small"
                      sx={{
                        backgroundColor: "white",
                        textTransform: "none",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {formData.image_path ? "Change Image" : "Select Image"}
                      <input
                        type="file"
                        accept="image/png, image/jpeg"
                        hidden
                        onChange={handleImageUpload}
                      />
                    </Button>

                    {formData.image_path && (
                      <img
                        src={formData.image_path}
                        alt="Preview"
                        style={{
                          width: 80,
                          height: 80,
                          objectFit: "cover",
                          borderRadius: 8,
                        }}
                      />
                    )}
                  </Box>

                  {validationErrors.image_path && (
                    <Typography color="error" fontSize={12} mt={0.5}>
                      {validationErrors.image_path}
                    </Typography>
                  )}
                </Grid>
                {/* Certificate Provided */}
                <Grid item xs={12} md={3}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="certificate_provided"
                        checked={Boolean(formData.certificate_provided)}
                        onChange={(e) =>
                          changeHandler({
                            target: {
                              name: "certificate_provided",
                              value: e.target.checked,
                            },
                          })
                        }
                      />
                    }
                    label="Certificate Provided"
                  />
                </Grid>
              </Grid>

              <Grid
                container
                alignItems="flex-end"
                justifyContent="flex-end"
                mt={2}
                spacing={1}
              >
                <Grid
                  container
                  item
                  xs={12}
                  md={isEdit ? 12 : 8}
                  justifyContent={"flex-start"}
                >
                  {/* <FormControlLabel
                    name="status"
                    control={
                      <Checkbox checked={Boolean(formData.status) || false} />
                    }
                    onChange={checkHandler}
                    label="Hide/Unhide"
                    style={{ marginRight: "20px" }}
                  /> */}
                </Grid>
                <Grid item xs={6} md={2}>
                  <Button
                    fullWidth
                    color={"secondary"}
                    onClick={clear}
                    variant="contained"
                    size="small"
                    title={"Reset"}
                    startIcon={<RotateLeftIcon />}
                  >
                    {"Reset"}
                  </Button>
                </Grid>
                <Grid item xs={6} md={2}>
                  <Button
                    fullWidth
                    onClick={handleSubmit}
                    variant="contained"
                    color={isEdit ? "success" : "primary"}
                    startIcon={isEdit ? <UpdateIcon /> : <SaveIcon />}
                    size="small"
                  >
                    {isEdit ? "Update" : "Save"}
                  </Button>
                </Grid>
                {isEdit === true && (
                  <Grid item xs={6} md={2}>
                    <Button
                      fullWidth
                      color="primary"
                      onClick={() => {
                        navigate("advance", { state: formData });
                      }}
                      variant="contained"
                      size="small"
                      startIcon={<AddPhotoAlternate />}
                    >
                      Add Img/Video
                    </Button>
                  </Grid>
                )}
                {isEdit === true && (
                  <Grid item xs={6} md={2}>
                    <Button
                      fullWidth
                      color="primary"
                      onClick={() => {
                        navigate(
                          `/master-entry/solution/faqs?company_id=${company_id}&id=${formData.id}&title=${formData.title}`
                        );
                      }}
                      variant="contained"
                      size="small"
                      startIcon={<LiveHelpIcon />}
                    >
                      Add FAQ'S
                    </Button>
                  </Grid>
                )}
                {isEdit === true && (
                  <Grid item xs={6} md={2}>
                    <Button
                      fullWidth
                      color="primary"
                      onClick={() => {
                        navigate(
                          `/master-entry/solution/add/chapters?company_id=${company_id}&id=${formData.id}&title=${formData.title}`
                        );
                      }}
                      variant="contained"
                      size="small"
                      startIcon={<LiveHelpIcon />}
                    >
                      Add Chapter
                    </Button>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </motion.div>
        </Container>
      )}

      <SolutionTable handleEdit={handleEdit} isChanged={isChanged} />
    </>
  );
};

export default Solutions;
